import React, { useCallback, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Link, useLocation, useParams } from 'react-router-dom'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import { ReactComponent as IconDeleteProduct } from '../../assets/images/icons/icon-delete.svg'
import TableListing from '../../components/TableListing/TableListing'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconView } from '../../assets/images/icons/icon-view-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconRejected } from '../../assets/images/icons/icon-rejected-status.svg'
import { ReactComponent as IconRejectedLabel } from '../../assets/images/icons/icon-rejected-red.svg'
import { ReactComponent as IconResume } from '../../assets/images/icons/resume.svg'
import requestApi from '../../utils/request'
import { productcatalog, viewproductdetails } from '../../config/routingConsts'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'
import { currencyFormateForRuppe } from '../../functions/common'
import ImageZoomModal from '../../components/ImageZoomModal/ImageZoomModal'
import Swal from 'sweetalert2'

// #region  API Call for view Vendor Data
const variantViewDetail = async (catalogId, productId) => {
    return await requestApi
        .post(
            `/catalog/variant/view`,
            { catalogId: catalogId, variantId: productId },
            { headers: true }
        )
        .then((res) => {
            return res.data
        })
}
// #endregion

const ViewVariantDetails = () => {
    const { catalogId, productId } = useParams()
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const [imageShow, setImageShow] = useState(false)
    const [imageGet, setImageGet] = useState(null)
    const queryClient = useQueryClient()

    const handleImageZoomModal = (imagePath) => {
        setImageShow(true)
        setImageGet(imagePath)
    }

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const { data: VariantData, isLoading } = useQuery({
        queryKey: [
            'product-variants-view'
            // currentPage,
            // DataLimit,
            // searchKeyword,
        ],
        queryFn: () => variantViewDetail(catalogId, productId),
        enabled: !!productId,
        onSuccess: (data) => {
            // reset({
            //     size:data?.data?.name
            // })
        },
        onError: (error) => {
            console.log(error.message)
        }
    })

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row.size, {
            id: 'size',
            header: () => 'Size',
            cell: (row) => {
                return (
                    <>
                        <span>
                            {row?.row?.original?.size}{' '}
                            {row?.row?.original?.sizeStatus === 7 && (
                                <span className="label-badge">New Size</span>
                            )}
                        </span>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row.availableQty, {
            id: 'availableQty',
            header: () => 'Available Qty',
            cell: (row) => {
                return (
                    <>
                        <span>{row?.row?.original?.availableQty}</span>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row.sellingPrice, {
            id: 'sellingPrice',
            header: () => 'Price (₹)',
            cell: (row) => (
                <span>
                    <b>
                        {currencyFormateForRuppe(
                            row?.row?.original?.sellingPrice
                        )}
                        {/* {row?.row?.original?.sellingPrice} */}
                    </b>
                </span>
            )
        }),
        columnHelper.accessor((row) => row.status, {
            id: 'status',
            header: () => 'Status',
            cell: (row) => {
               return(
                <label className="switch">
                <input
                    type="checkbox"
                    checked={
                        row?.row?.original?.status == 1
                            ? true
                            : false
                    }
                    onChange={(e) =>
                        onStatusChange(
                            row?.row?.original?.sizeId,
                            row?.row?.original?.status
                        )
                    }
                />
                <span className="slider round"></span>
            </label>
               )
            }
        }),
    ]

    const table = useReactTable({
        data: VariantData?.data?.variantList || [],
        columns: columns,
        // onSortingChange: setSorting,
        // getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //#region  Active/InActive Status Update
const onStatusChange = useCallback((sizeId,currentStatus) => {
    mutationStatusActiveInactive.mutate({ sizeId,currentStatus })
}, [])
async function updateStatusbyvariantId(variant) {
    const { sizeId,currentStatus } = variant
    console.log(currentStatus,"currentStatus");
    return await requestApi.post(`/catalog/variant/size/active-Inactive`, {
        variantId: productId,
        catalogId: catalogId,
        sizeId: sizeId,
        status:currentStatus
        
    })
}
const mutationStatusActiveInactive = useMutation(updateStatusbyvariantId, {
    onSuccess: ({ data }) => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: '',
            text: data?.meta?.message
        })
        queryClient.invalidateQueries('vendor-view')
    },
    onError: (error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: '',
            text: error?.message
        })
    }
})
//#endregion

    return (
        <div>
            <div className="view-product-details">
                <ul className="site-breadcrumb">
                    <li>
                        <Link to={productcatalog}>Product Catalog</Link>
                    </li>
                    <li>
                        <Link to={-1}>View Product Details</Link>
                    </li>
                    <li>View Variant Details</li>
                </ul>
                <div className="admin-card">
                    <div className="head">
                        <h2>{VariantData?.data?.color} Variants</h2>
                        {/* <div className="search-btn-group">
                            <form className="product-table-filter">
                                <input
                                    type="search"
                                    name="colorSearch"
                                    placeholder="Search Variant"
                                />
                            </form>
                        </div> */}
                    </div>
                    <div className="product-image-list">
                        {VariantData?.data?.productImages?.map(
                            (productImg, i) => {
                                return (
                                    <img
                                        src={productImg?.image}
                                        alt="image"
                                        key={i}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            handleImageZoomModal(
                                                productImg?.image
                                            )
                                        }
                                    />
                                )
                            }
                        )}
                    </div>
                    {isLoading ? (
                        <TableSkeleton />
                    ) : VariantData?.data?.variantList.length > 0 ? (
                        <TableListing table={table} className="m-0" />
                    ) : (
                        <div className="no-record-found">No Record Found</div>
                    )}
                </div>
            </div>

            <ImageZoomModal
                imageShow={imageShow}
                setImageShow={setImageShow}
                imageGet={imageGet}
            />
        </div>
    )
}

export default ViewVariantDetails
